import { useContext } from 'react';
import context, { Context } from 'components/AgentProvider/context';

const useAgentData = () => useContext<Context>(context);

export default useAgentData;
